import React, { useEffect } from 'react';
import { InfoIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface DisclaimerModalProps {
  open: boolean;
  onClose: () => void;
}
export const DisclaimerModal: React.FC<DisclaimerModalProps> = ({
  open,
  onClose
}) => {
  // Close on Escape for accessibility
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-180">
      {open && <motion.div className="fixed inset-0 z-[100] flex items-center justify-center p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} aria-hidden={!open} data-id="element-181">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-[#000000]/60 backdrop-blur-sm" onClick={onClose} data-id="element-182" />

          {/* Modal */}
          <motion.div role="dialog" aria-modal="true" aria-labelledby="disclaimer-title" aria-describedby="disclaimer-body" className="relative w-full max-w-lg bg-white rounded-md shadow-[0_24px_60px_rgba(0,0,0,0.25)] overflow-hidden" initial={{
        opacity: 0,
        scale: 0.94,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} transition={{
        type: 'spring',
        stiffness: 320,
        damping: 26
      }} data-id="element-183">
            {/* Branded header band */}
            <div className="bg-[#000000] px-8 sm:px-10 py-7 text-center" data-id="element-184">
              <p className="text-[11px] font-semibold tracking-[0.2em] uppercase text-white/60 mb-3" data-id="element-185">
                Lenovo EMEA
              </p>
              <div className="flex justify-center mb-4" data-id="element-186">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/10 ring-1 ring-white/15" data-id="element-187">
                  <InfoIcon className="h-6 w-6 text-white" data-id="element-188" />
                </div>
              </div>
              <h2 id="disclaimer-title" className="text-xl font-bold text-white" data-id="element-189">
                About This Report
              </h2>
            </div>

            {/* Body */}
            <div id="disclaimer-body" className="px-8 sm:px-10 py-8 text-left space-y-5" data-id="element-190">
              <p className="text-base text-[#404040] leading-relaxed" data-id="element-191">
                This is an illustrative Brandpulse attention pre-test prepared
                for Lenovo EMEA. It is designed to give you a feel for how the
                final report reads, comparing four creative variants across two
                defined audience segments on stopping power, audience signals
                and attention.
              </p>

              <p className="text-sm text-[#737373] leading-relaxed" data-id="element-192">
                No real test was run. The results are fictional example data
                based on our attention blueprint and benchmark databases of
                prior tests, not a measurement of real-world viewing behaviour.
              </p>

              {/* Primary Button */}
              <button onClick={onClose} className="w-full bg-[#0D5C91] hover:bg-[#0A4A75] text-white font-medium py-3 px-6 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-[#0D5C91]/40 focus:ring-offset-2 mt-2" data-id="element-193">
                Explore the report
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};